module.exports = __webpack_public_path__ + "static/img/333.1b45253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/air/333.png
// module id = bi8R
// module chunks = 0